import { Paragraph4 } from '@nexus/lib-react/dist/core/Typography/Paragraph';
import mq from '../../styles/mediaQueries';
import styled from '../../../theme/styled';

const Wrapper = styled.div`
  height: 100%;
  width: 100%;
`;

const Paragraph = styled(Paragraph4)`
  margin: 16px 32px;
  text-align: center;
  font-family: ${({ theme }) => theme.colors.grey4};

  ${mq.desktop} {
    margin: 16px;
  }
`;

export default {
  Wrapper,
  Paragraph,
};
